import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {first} from 'rxjs/operators';
import {OrderService} from '../../../../services/order.service';
import {OrderModel} from '../../../../models/order.model';
import {PHONE_MASK, PHONE_PATTERN, SNACK_CONFIG, STATUSES} from '../../../../global';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog, MatDialogConfig, MatSnackBar} from '@angular/material';
import {ConfirmDialogComponent} from '../../../../components/confirm-dialog/confirm-dialog.component';
import {SharedService} from '../../../../services/shared.service';
import {CustomerService} from '../../../../services/customer.service';
import {RateDialogComponent} from '../../../../components/rate-dialog/rate-dialog.component';
import {RescheduleDialogComponent} from '../../../../components/reschedule-dialog/reschedule-dialog.component';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  statusClass: string = '';
  order: OrderModel;
  statuses: Array<string> = STATUSES;
  showLoader: boolean = true;
  driverGreeting: string;
  phoneMask = PHONE_MASK;
  sendAppLoader: boolean;
  sendMeAppPhone: string;
  dialogOpen: boolean;

  constructor(private activated: ActivatedRoute,
              private orderService: OrderService,
              private translate: TranslateService,
              private customerService: CustomerService,
              private shared: SharedService,
              private dialog: MatDialog,
              private snackBar: MatSnackBar) {
    this.activated.params
      .pipe(first())
      .toPromise()
      .then(params => {
        this.orderService.getOrderInfo(params['orderId'])
          .subscribe(order => {
            let statusClasses = ['', '', 'assigned', 'onRoute', 'arrived', 'delivered', 'delivered', 'delivered', 'delivered', ''];
            this.order = order;
            this.statusClass = statusClasses[order.status];
            this.showLoader = false;
            const dialogConfig = new MatDialogConfig();
            dialogConfig.autoFocus = true;
            dialogConfig.disableClose = true;
            let dialogComponent;
            if (order.status == 9) {
              dialogConfig.data = {order: order};//Pass order to dialog
              dialogComponent = RescheduleDialogComponent;
            }
            if (order.status == 5 && !order.rating) {
              dialogConfig.data = {
                order: order,
                title: 'RATING.HOO',
                message: 'RATING.FINISHED',
                rateText: 'RATING.RATETEXT'
              };
              dialogComponent = RateDialogComponent;
            }
            if (dialogComponent && !this.dialogOpen) {
              this.dialogOpen = true;
              this.dialog.open(dialogComponent, dialogConfig);
            }
            if (order.driver) {
              this.translate.get('ORDERDETAILS.DRIVERGREETINGS', {name: order.driver.name})
                .pipe(first())
                .toPromise()
                .then(message => {
                  this.driverGreeting = message;
                });
            }
          });
      });
  }

  ngOnInit() {
  }

  cancelOrder() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      message: 'ORDERCANCEL',
      type: 'cancel_order'
    };
    let dRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dRef.componentInstance.confirmed.pipe(first()).toPromise()
      .then(event => {
        if (event.type = 'cancel_order') {
          this.orderService.updateOrder(this.order.id, {status: 6})
            .then(_ => {
              //Order canceled
            })
            .catch(err => {
              this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Please try again'});
            });
        }
      });
  }

  sendMeApp(phone) {
    if (phone && phone.match(PHONE_PATTERN)) {
      this.sendAppLoader = true;
      this.sendMeAppPhone = null;
      let number = phone.match(/\d/g).join('');
      this.customerService.sendMeApp('+1', number)
        .then(res => {
          this.sendAppLoader = false;
          this.snackBar.open('Message sent', null, SNACK_CONFIG);
        })
        .catch(res => {
          this.sendAppLoader = false;
          let err = res.error || res;
          let error = {title: 'Error', body: err.errorMessage || err.message || 'Unexpected error. Please try again'};
          this.shared.openErrorDialog(error);
        });

    }
  }

}
